export default "/images/b418a51f3e5f2267247844208cf65d29.avif";